var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_c('ul',{staticClass:"nav-menu"},_vm._l((_vm.navList),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.path}},[_c('li',{staticClass:"nav-menu-item"},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }